import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthenticationService } from '../../services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigSystemParams, dropdownSelectAllValues } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';
import { UsersService } from '../../services/utelize/system/user/users-service';

@Component({
  selector: 'app-dropdown-user',
  templateUrl: './dropdown-user.component.html',
  styleUrls: ['./dropdown-user.component.scss']
})

export class DropdownUserComponent implements AfterViewInit, OnChanges, OnInit {

  @Input() companyId                  : number  | undefined;
  @Input() disabled                   : boolean | undefined;
  @Input() initialUserId              : number  | undefined;
  @Input() labelTop                   : boolean = true;  //CRN_20260529 - false=left of field
  @Input() retainFirstBlankOption     : boolean | undefined;
  @Input() showHierarchySureSimDevices: boolean | undefined;
  @Input() showCompanySureSimDevices  : boolean | undefined;
  
  @Output() selectOnChangeEvent: EventEmitter<number>=new EventEmitter<number>();
  
  get selectAllOption() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsProvideSelectAllOption, false ); }

  private userIdData!     : IdAndDescriptionDTO[];
  private curUserCompanyId: number;

  public addOrEditForm! : UntypedFormGroup;
  public firstUserOption: string="";
  
  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : FormBuilder,
    private usersService         : UsersService
  ) {
    this.curUserCompanyId=this.authenticationService.currentUserObject().companyId;
  }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      let userId          =this.initialUserId==undefined ? 0 : this.initialUserId;
      this.firstUserOption=!this.retainFirstBlankOption && this.selectAllOption ? dropdownSelectAllValues.User : "";

      this.addOrEditForm=this.formBuilder.group({
        userID: [userId, []]
      });

      this.applyDisabledState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['disabled']) {
        this.applyDisabledState();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearSelection() {
    try {
       this.addOrEditForm.get('userID')?.reset();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.userIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private applyDisabledState(): void {
    try {
      const control=this.addOrEditForm?.get('userID');

      if (control==undefined)
        return;

      if (this.disabled && control.enabled)
        control.disable({ emitEvent: false });
      
      else if (!this.disabled && control.disabled)
        control.enable({ emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getDropdownData() {
    try {
      let dataSource: Observable<IdAndDescriptionDTO[]>;

      if (this.showHierarchySureSimDevices) {
        dataSource=this.usersService.getIdAndDescriptionForHierarchy(this.companyId);

      } else if (this.showCompanySureSimDevices) {
        dataSource=this.usersService.getIdAndDescriptionByCompanyId(this.companyId ?? -1);

      } else {
        dataSource=this.usersService.getIdAndDescriptionByCompanyId(this.curUserCompanyId)
      }

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.userIdData=(data as IdAndDescriptionDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshData() {
    this.getDropdownData();
  }
  
  public selectOnChange(event: Event | undefined) {
    try {
      let userID=this.addOrEditForm.controls["userID"].value;

      if (isNaN(userID) || userID=="") {
        userID=-1;
      }

      this.selectOnChangeEvent.emit(userID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
